import React from 'react'

interface FileFormatOption {
  id: string
  label: string
}

interface ProductFormatsSelectorProps {
  fileFormatOptions: FileFormatOption[]
  selectedFormats: string[]
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const ProductFormatsSelector: React.FC<ProductFormatsSelectorProps> = ({
  fileFormatOptions,
  selectedFormats,
  onChange
}) => {
  return (
    <div className='formats-selector'>
      <label>Dostępne formaty plików*</label>
      <div className='formats-list mt-2'>
        {fileFormatOptions.map(format => (
          <div className='custom-control custom-checkbox d-inline-block mr-3 mb-2' key={format.id}>
            <input
              type='checkbox'
              className='custom-control-input'
              id={`format-${format.id}`}
              name='fileFormats'
              value={format.id}
              checked={selectedFormats.includes(format.id)}
              onChange={onChange}
            />
            <label className='custom-control-label' htmlFor={`format-${format.id}`}>
              {format.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProductFormatsSelector
